import type { Match3 } from 'src/replicant/minigame/match3';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PuzzleReward = 'points' | 'gems';
export type ReadyState = 'hidden' | 'ready' | 'go' | 'finish';

const match3 = createSlice({
  name: 'match3',

  initialState: {
    board: [] as Match3.BoardState,
    matching: false,
    readyState: 'hidden' as ReadyState,
    rewards: {} as Partial<Record<PuzzleReward, number>>,
    playing: false,
  },

  reducers: {
    setBoardState(state, { payload }: PayloadAction<Match3.BoardState>) {
      state.board = payload;
    },

    setMatching(state, { payload }: PayloadAction<boolean>) {
      state.matching = payload;
    },

    setPuzzleReadyState(state, { payload }: PayloadAction<ReadyState>) {
      state.readyState = payload;
    },

    setPlaying(state, { payload }: PayloadAction<boolean>) {
      state.playing = payload;
    },
  },
});

export const match3Actions = match3.actions;
export default match3.reducer;
